import InfoCircle from '../../assets/info-circle.svg';
import Tooltip from '@mui/material/Tooltip';

export default function InfoMessage({ message }: { message: string }) {
    return (
        <Tooltip title={message}>
            <img src={InfoCircle} alt='info-icon' className='w-[14px] h-[14px] hover:cursor-pointer opacity-[0.5] hover:opacity-[1] transition-all'/>
        </Tooltip>
    )
}